import { faro } from '@grafana/faro-react'

import React, { useEffect } from 'react'

type SafeFreestarWrapperProps = {
  children: React.ReactNode
  logRenderEvent?: boolean
  source: string
}

type ErrorBoundaryProps = {
  children: React.ReactNode
  placementName?: string
  source: string
}

type ErrorBoundaryState = {
  hasError: boolean
}

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError(_: Error): ErrorBoundaryState {
    return { hasError: true }
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    faro.api.pushError(error, {
      context: {
        source: this.props.source,
        placementName: this.props.placementName || '',
        componentStack: errorInfo.componentStack || ''
      }
    })
  }

  render() {
    if (this.state.hasError) return null
    return this.props.children
  }
}

const SafeFreestarWrapper: React.FC<SafeFreestarWrapperProps> = ({ children, logRenderEvent = true, source }) => {
  let placementName: string | undefined

  if (React.isValidElement(children)) {
    placementName = (children.props as { placementName?: string })?.placementName
  }

  useEffect(() => {
    if (logRenderEvent && placementName) {
      faro.api.pushEvent(`${source}/${placementName}/AttemptRender`, {
        placementName,
        timestamp: Date.now().toLocaleString()
      })
    }
  }, [source, placementName, logRenderEvent])

  return (
    <ErrorBoundary source={source} placementName={placementName}>
      {children}
    </ErrorBoundary>
  )
}

export default SafeFreestarWrapper
